import React from 'react';
import { useIntl } from 'react-intl';

import { Button, FieldWrapper, List, ListItemProps, Popper } from '@xsolla/ui-core';
import { ChevronDownMini } from '@xsolla/ui-icons';

import {
  SettingsBar as SettingsBarWrapper,
  SettingsBarLabel,
  SettingsBarOptionsButton
} from './style';
import { ViewModeButton } from './ViewModeButton';

type Props = {
  label?: string;
  popperLabel?: string;
  options?: ListItemProps[];
  switchPreview: () => unknown;
  customizeHandle?: () => unknown;
  isPreview: boolean;
  disableCustomization?: boolean;
};

const SettingsBar = ({
  label,
  popperLabel,
  options,
  switchPreview,
  isPreview,
  customizeHandle,
  disableCustomization = false
}: Props): JSX.Element => {
  const intl = useIntl();

  return (
    <SettingsBarWrapper extraSettings={!!label || !!options}>
      {(label || options) && (
        <div>
          <FieldWrapper>
            {label && (
              <SettingsBarLabel data-test-id="settings-bar_label">{label}</SettingsBarLabel>
            )}
            {options && (
              <Popper entry={<List items={options} />} placement="bottom-start">
                {(e) => (
                  <SettingsBarOptionsButton
                    {...e}
                    data-test-id="settings-bar_options-button"
                    style={{ minWidth: '160px' }}
                    look="link"
                    palette="brand"
                    size="sm">
                    {popperLabel}
                    <ChevronDownMini />
                  </SettingsBarOptionsButton>
                )}
              </Popper>
            )}
          </FieldWrapper>
        </div>
      )}
      <ViewModeButton onClick={switchPreview} isPreview={isPreview} />
      {customizeHandle && (
        <Button
          onClick={customizeHandle}
          look="default"
          palette="brand"
          size="sm"
          data-test-id="settings-bar_customization-button"
          disabled={disableCustomization}>
          {intl.messages['widget-customization.settings.bar.customize']}
        </Button>
      )}
    </SettingsBarWrapper>
  );
};

export default SettingsBar;
